export enum galleryTypes {
    FETCH_GALLERY_REQUEST = 'FETCH_GALLERY_REQUEST',
    FETCH_GALLERY_ITEM_BY_ID = 'FETCH_GALLERY_ITEM_BY_ID',
    CREATE_GALLERY_REQUEST = 'CREATE_GALLERY_REQUEST',
    EDIT_GALLERY_ITEM_REQUEST = 'EDIT_GALLERY_ITEM_REQUEST',
    DELETE_GALLERY_ITEM_REQUEST = 'DELETE_GALLERY_ITEM_REQUEST',
    SET_GALLERY = 'SET_GALLERY',
    SET_GALLERY_ITEM = 'SET_GALLERY_ITEM',
}
